// src/controllers/tattoo_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  hit() {
    let url = this.data.get("url");
    fetch(url, { method: "POST" });
  }
}
